import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './styles.module.scss';

const BodyEmphasis = (props) => (
  <span {...props} className={cn(styles.bodyEmphasis, props.className)} />
);

BodyEmphasis.propTypes = {
  className: PropTypes.string,
};

export default BodyEmphasis;
